import { Injectable } from '@angular/core';

@Injectable()
export class EnviromentGlobalService {

	// The values that are defined here are the default values that can
	// be overridden by env.js

	// API url
	get apiUrl(): string {
		const browserWindow = window || {};
		const browserWindowEnv = browserWindow['__env'] || {};
		console.log(browserWindowEnv);
		
		// Assign environment variables from browser window to env
		// In the current implementation, properties from env.js overwrite defaults from the EnvService.
		// If needed, a deep merge can be performed here to merge properties instead of overwriting them.
		// tslint:disable-next-line:forin
		for (const key in browserWindowEnv) {
			if (browserWindowEnv.hasOwnProperty(key) && 'apiUrl' === key) {
				return window['__env'][key];
			}
		}

		return null;
	}

	// Amazon Image
	get amazonImage(): string {
		const browserWindow = window || {};
		const browserWindowEnv = browserWindow['__env'] || {};
		// Assign environment variables from browser window to env
		// In the current implementation, properties from env.js overwrite defaults from the EnvService.
		// If needed, a deep merge can be performed here to merge properties instead of overwriting them.
		// tslint:disable-next-line:forin
		for (const key in browserWindowEnv) {
			if (browserWindowEnv.hasOwnProperty(key) && 'amazonImage' === key) {
				return window['__env'][key];
			}
		}

		return null;
	}

	// id Google Analytic
	get idGoogleAnalytic(): string {
		const browserWindow = window || {};
		const browserWindowEnv = browserWindow['__env'] || {};
		// Assign environment variables from browser window to env
		// In the current implementation, properties from env.js overwrite defaults from the EnvService.
		// If needed, a deep merge can be performed here to merge properties instead of overwriting them.
		// tslint:disable-next-line:forin
		for (const key in browserWindowEnv) {
			if (browserWindowEnv.hasOwnProperty(key) && 'idGoogleAnalytic' === key) {
				return window['__env'][key];
			}
		}

		return null;
	}

	// Whether or not to enable debug mode
	get enableDebug(): boolean {
		const browserWindow = window || {};
		const browserWindowEnv = browserWindow['__env'] || {};

		// Assign environment variables from browser window to env
		// In the current implementation, properties from env.js overwrite defaults from the EnvService.
		// If needed, a deep merge can be performed here to merge properties instead of overwriting them.
		// tslint:disable-next-line:forin
		for (const key in browserWindowEnv) {
			if (browserWindowEnv.hasOwnProperty(key) && 'production' === key) {
				return window['__env'][key];
			}
		}

		return false;
	}

}
